import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, labelModes } from '@/utils'

import button from '@/components/button'
import selectorOwner from '@/components/selector/owner'

function renderField(h, item, index) {
  let type = 'password'
  let afterIcon = icons.visibility
  if (this.revealed[index]) {
    type = 'text'
    afterIcon = icons.visibility_off
  }

  return h(
    'div',
    {
      class: `${Services.providers}-user-api-keys__row`
    },
    [
      h(
        selectorOwner,
        {
          props: {
            value: item.key,
            label: this.getTranslate(`${Services.providers}.labels.userApiKeys.userId`),
            itemsDisabled: this.disabledUserIds(index),
            labelMode: labelModes.hidden,
            dense: true
          },
          on: {
            input: event => {
              item.key = event
            }
          }
        }
      ),
      h(
        components['text-field'],
        {
          props: {
            value: item.value,
            label: this.getTranslate(`${Services.providers}.labels.userApiKeys.apiKey`),
            type,
            afterIcon,
            afterIconCallback: () => {
              this.toggleVisibility(index)
            },
            labelMode: labelModes.hidden,
            dense: true,
            details: false,
            clearable: true
          },
          on: {
            input: event => {
              item.value = event
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            icon: icons.remove,
            mode: buttonModes.flat,
            color: Colors.error
          },
          on: {
            click: () => {
              this.removeField(index)
            }
          }
        }
      )
    ]
  )
}

function renderFields(h) {
  return h(
    'div',
    {
      class: `${Services.providers}-user-api-keys__fields`
    },
    this.proxy.map((item, index) => {
      return renderField.call(this, h, item, index)
    })
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: `${Services.providers}-user-api-keys__footer`
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.add,
            mode: buttonModes.flat,
            color: Colors.primary
          },
          on: {
            click: () => {
              this.addField()
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.providers}-user-api-keys`
    },
    [
      renderFields.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
